import React, { ReactNode, useContext, useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import { Form, Formik, FormikProps } from "formik";
import * as Yup from "yup";
import CustomDialog from "../../components/Dialog/CustomDialog";
import CustomTextField from "../../components/Input/CustomTextField";
import CustomButton from "../../components/Button/CustomButton";
import { TestRequestContext } from "../../contexts/TestRequestContext";
import InfoBox from "../../components/InfoBox";

const exampleTitle = `${new Date().getFullYear()} - 00042 - EU-ES`;

const infoText = `
  The additional title name is an individual text that is shown after the auto-generated title (e.g. ${exampleTitle})
  to help identifying this test request. Adjust it to a title that fits to you and makes it more recognizable.
`;

export interface EditRequestNameDialogProps {
  open: boolean;
  onSave: (value: string) => void;
  onClose: () => void;
}

const EditRequestNameDialog: React.FC<EditRequestNameDialogProps> = (props) => {
  const { open, onSave, onClose } = props;
  const { testRequestTitleSuffix } = useContext(TestRequestContext);
  const yupValidationSchema = Yup.object().shape({
    requestName: Yup.string(),
  });
  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    if (open) {
      setEditMode(Boolean(testRequestTitleSuffix));
    }
  }, [open]);

  return (
    <CustomDialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
      <h2>{editMode ? "EDIT" : "ADD"} ADDITIONAL TITLE NAME</h2>
      <Formik
        initialValues={{
          requestTitleSuffix: testRequestTitleSuffix,
        }}
        onSubmit={(values): void => {
          onSave(values.requestTitleSuffix);
        }}
        validationSchema={yupValidationSchema}
      >
        {(formikProps: FormikProps<{ requestTitleSuffix: string }>): ReactNode => {
          // formik inner jsx form
          const { errors, handleBlur, handleChange, isSubmitting, touched, values } = formikProps;

          return (
            <Form>
              <Grid container direction="column" spacing={3}>
                <Grid item>
                  <InfoBox text={infoText}>
                    <CustomTextField
                      autoFocus
                      fullWidth
                      name="requestTitleSuffix"
                      id="requestTitleSuffix"
                      label="Additional Title Name"
                      value={values.requestTitleSuffix}
                      helperText={[
                        errors.requestTitleSuffix && touched.requestTitleSuffix ? errors.requestTitleSuffix : "",
                      ].join(" ")}
                      error={!!(errors.requestTitleSuffix && touched.requestTitleSuffix)}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </InfoBox>
                </Grid>
                <Grid container item direction="row" justify="flex-end">
                  <CustomButton disabled={isSubmitting} primary text="Save" type="submit" />
                </Grid>
              </Grid>
            </Form>
          );
        }}
      </Formik>
    </CustomDialog>
  );
};

export default EditRequestNameDialog;
